import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types'
import Input from '../../1_Atoms/Forms/Input/Input';
import Button from '../../1_Atoms/Button/Button';
import FormGroup from '../../2_Molecules/FormGroup/FormGroup';
import { handleRequest } from '../../../utils/httpRequest';
import { getEndpointUrl } from '../../../utils/endPoints';
import Form from '../../2_Molecules/Form/Form';
import { languageController } from '../../../controllers/language/languageController';
import { useForm } from '../../../hooks/useForm';
import FormContainer from '../../2_Molecules/FormContainer/FormContainer';
import FormConfirmation from '../../2_Molecules/FormConfirmation/FormConfirmation';
import Checkbox from '../../1_Atoms/Forms/Checkbox/Checkbox';
import parse from 'html-react-parser';
import Modal from '../../2_Molecules/Modal/Modal';
import { Tabs } from '../../2_Molecules/Tabs/Tabs';
import { autoFormatPhoneNumber } from '../../../utils/helpers';

function ShareBuildModal({ formExtraParams }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formError, setFormError] = useState(null);
  const [isModalClosed, setIsModalClosed] = useState(false);
  const [activeTab, setActiveTab] = useState('email');

  const { language } = formExtraParams

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    buildname: '',
    recipientName: '',
    recipientEmail: '',
    recipientPhone: '',
    optin: false,
  }

  const validations = {
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    buildname: ['required'],
    recipientName: ['required', 'name'],
    recipientEmail: activeTab === 'email' ? ['required', 'email'] : [],
    recipientPhone: activeTab === 'sms' ? ['required', 'phone'] : [],
  }

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {
        console.log('SUBMITTING')
        // TODO: Complete here when the BE api is ready.
        // Adjust operations here based on activeTab.
        // const endPointUrl = getEndpointUrl('');
        // const res = await handleRequest('post', endPointUrl, data});
        // if (res.Success) {
        setIsSubmitted(true);
        setData(initState)
        // } else {
        //   setFormError(res.state ? res.state : res.Errors[0])
        // }
      } catch (err) {
        console.log(err)
      }
    },
  })

  const { firstname, lastname, email, buildname, optin, recipientName, recipientEmail, recipientPhone } = data;

  return (
    <Modal
      className="mz-share-build-modal mz-modal-form"
      id="mz-react-share-build-modal"
      isOpen={!isModalClosed && isSubmitted}
      // isOpen={true}
    >
      <FormContainer
        className="mz-share-build"
        isSubmitted={isSubmitted}
        heading={(
          <Fragment>
            <h3>{languageController.getCopy('shareBuild', 'heading')}</h3>
            <p>{languageController.getCopy('shareBuild', 'subHeading')}</p>
          </Fragment>
        )}
        confirmation={(
          <FormConfirmation
            heading={languageController.getCopy('shareBuild', 'confirmationHeading')}
            subHeading={languageController.getCopy('shareBuild', 'confirmationSubHeading')}
            buttonLabel={languageController.getCopy('shareBuild', 'confirmationSubmit')}
            onClick={() => setIsModalClosed(true)}
          />
        )}
        disclaimer={(
          <Checkbox
            name="optin"
            checked={optin}
            onChange={(e) => setData({ ...data, optin: !optin })}
            label={parse(languageController.getCopy('global', 'subscribeLegal'))}
          />
        )}
      >
        <Tabs
          setVisibleTab={(id) => setActiveTab(id)}
          activeTab={activeTab}
          dataTabs={[
            {
              id: 'email',
              tabTitle: languageController.getCopy('shareBuild', 'byEmail'),
            },
            {
              id: 'sms',
              tabTitle: languageController.getCopy('shareBuild', 'bySMS'),
            },
          ]}
        />
        <Form
          onSubmit={handleSubmit}
          isDark={false}
          noValidate={true}
          errorMessage={formError}
        >
          <FormGroup md={2}>
            <Input
              type="text"
              name="firstname"
              label={languageController.getFormCopy('label', 'firstname')}
              value={firstname}
              isRequired={true}
              errorMessage={errors.firstname}
              onChange={handleChange}
              maxLength={50}
            />
            <Input
              type="text"
              name="lastname"
              label={languageController.getFormCopy('label', 'lastname')}
              value={lastname}
              isRequired={true}
              errorMessage={errors.lastname}
              onChange={handleChange}
              maxLength={50}
            />
          </FormGroup>
          <Input
            type="email"
            name="email"
            label={languageController.getFormCopy('label', 'email')}
            value={email}
            isRequired={true}
            errorMessage={errors.email}
            onChange={handleChange}
            maxLength={320}
          />
          <Input
            type="text"
            name="buildname"
            label={languageController.getFormCopy('label', 'buildName')}
            value={buildname}
            isRequired={true}
            errorMessage={errors.buildname}
            onChange={handleChange}
            maxLength={100}
          />
          <FormGroup md={2}>
            <Input
              type="text"
              name="recipientName"
              label={languageController.getFormCopy('label', 'recipientName')}
              value={recipientName}
              isRequired={true}
              errorMessage={errors.recipientName}
              onChange={handleChange}
              maxLength={50}
            />
          </FormGroup>
          {
            activeTab === 'email' ? (
              <Input
                type="email"
                name="recipientEmail"
                label={languageController.getFormCopy('label', 'recipientEmail')}
                value={recipientEmail}
                isRequired={true}
                errorMessage={errors.recipientEmail}
                onChange={handleChange}
                maxLength={320}
              />
              ) : (
              <Input
                type="tel"
                name="recipientPhone"
                label={languageController.getFormCopy('label', 'recipientPhone')}
                value={recipientPhone}
                isRequired={true}
                errorMessage={errors.recipientPhone}
                onChange={(e) => {
                  setData({ ...data, recipientPhone: autoFormatPhoneNumber(e.target.value) });
                }}
                maxLength={17}
              />
            )
          }
          <Button
            type="submit"
            className="mz-btn--primary mz-btn--red"
            label={languageController.getCopy('shareBuild', 'submit')}
          />
        </Form>
      </FormContainer>
    </Modal>
  )
}

ShareBuildModal.propTypes = {
  formExtraParams: PropTypes.object
}

export default ShareBuildModal